import React, {createContext, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";

import {initOAuth} from "../components/Utils/oauth";
import {FetchErrorProps, OAuthContextProps, OAuthDataProps, OAuthProviderProps} from "./type";
import {oauthDataDefaultValue} from "./const";
import {OAuth} from "@prowin/oauth2-client";

export const OAuthContext = createContext<OAuthContextProps>({
    oauthData: oauthDataDefaultValue,
    errorOauth: {error: false, message: ""},
    setErrorOauth: () => {
    }
});

export const OAuthProvider: React.FC<OAuthProviderProps> = ({children}) => {
    const {t} = useTranslation('common');
    const [oauthData, setOAuthData] = useState<OAuthDataProps>({...oauthDataDefaultValue})

    const [errorOauth, setErrorOauth] = useState<FetchErrorProps>({error: false, message: ""})

    useEffect(() => {
        // setLists(applications)
        initOAuth(t).then(res => {
            const oauthValue = { ...res, doLogout: () => res.doLogout(), doRefreshToken: () => res.refreshToken(), getJwtData: () => res.getJwtData(), isTokenExpired: () => res.token.expired() }
            setOAuthData({...oauthValue})
        }).catch((oauthError: {error: any, oauth: OAuth}) => {
            const {error, oauth} = oauthError;
            oauth.clearToken();
            setErrorOauth(prevState => ({...prevState, error: true, message: error.message}));
            window.location.reload();
        });

    }, [t])

    const defaultOAuthContextValue = {oauthData, errorOauth, setErrorOauth};

    return <OAuthContext.Provider value={defaultOAuthContextValue}>
        {children}
    </OAuthContext.Provider>
}